// extracted by mini-css-extract-plugin
export default {"main":"b631a44626 _9d09f3795a _067d22f455 _468f899e02","title":"_2c0bd08d84"};